import {
  InvoiceDetailsForDiscussion,
  InvoiceNewsFeed,
  InvoicingDiscussionProps,
  PostInvoiceProps,
} from '../../../../../../types/ProjectManagement/Project/ProjectView/Invoices/invoiceDiscussionListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import {
  AllowedHttpMethods,
  InvoiceDiscussionApiConfig,
} from '../../../../apiList'

const invoiceDetailsForDiscussion = async (
  id: number,
): Promise<InvoiceDetailsForDiscussion> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceDiscussionApiConfig.invoiceDetailsForDiscussion,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const invoiceNewsFeed = async (
  props: InvoicingDiscussionProps,
): Promise<InvoiceNewsFeed[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceDiscussionApiConfig.invoiceNewsFeed,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId: props.invoiceId,
      projectid: props.projectid,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const postProjectInvoice = async (
  postInvoiceProps: PostInvoiceProps,
): Promise<number | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: InvoiceDiscussionApiConfig.projectnewsfeed,
    method: AllowedHttpMethods.post,
    data: postInvoiceProps,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const invoicingApi = {
  invoiceDetailsForDiscussion,
  invoiceNewsFeed,
  postProjectInvoice,
}
export default invoicingApi
